import { useDispatch, useSelector } from 'react-redux';
import store from '@store';
import parentApi from '../store/parentApi';

export const useQueryUpdate = () => {
  const dispatch = useDispatch();
  const updateQueryData = (endpoint, cb, handleArgs) => {
    let parentState = store.getState().parentApi;
    const args = getEndPointArgs(endpoint, parentState, handleArgs);
    dispatch(parentApi.util.updateQueryData(endpoint, args, cb));
  };
  return [updateQueryData];
};

export const getEndPointArgs = (endpoint, parentState, handleArgs) => {
  const endpointPrefix = Array.isArray(endpoint) ? String(endpoint[0]) : String(endpoint);
  const items = Object.keys(parentState.subscriptions).filter((e) => e.startsWith(endpointPrefix));
  const itemKey = items.find((e) => !!Object.keys(parentState.subscriptions[e])?.length);
  if (!itemKey) return undefined;
  const open = itemKey.indexOf('(');
  const close = itemKey.lastIndexOf(')');
  if (open === -1 || close <= open) return undefined;
  const argsStr = itemKey.slice(open + 1, close);
  if (!argsStr || argsStr === 'undefined') return undefined;
  let parsed;
  try {
    parsed = JSON.parse(argsStr);
  } catch {
    return undefined;
  }
  return handleArgs ? handleArgs(parsed) : parsed;
};

export const useGetQueryCachedData = (queryName) => {
  const queryArgs = getEndPointArgs([queryName], store.getState().parentApi);
  const data = useSelector((state) => parentApi.endpoints?.[queryName]?.select(queryArgs)(state)?.data);
  return data;
};
